<template>
  <custom-dialog :visible="visible" width="1000px" class="replace-parts-dialog" :title="model.title" v-on="$listeners">
    <div class="dialog-body">
      <div class="msg-content">
        <div class="title">{{ $t('dms_replace_parts_dialog.she_bei_xin_xi') }}</div>
        <ul class="msg-list">
          <li>
            <div class="key">{{ $t('dms_replace_parts_dialog.pin_pai') }}</div>
            <div class="val">{{ model.data.productBrand }}</div>
          </li>
          <li>
            <div class="key">{{ $t('dms_replace_parts_dialog.chan_pin_xing_hao') }}</div>
            <div class="val">{{ model.data.productCode }}</div>
          </li>
          <li>
            <div class="key">{{ $t('dms_replace_parts_dialog.ji_shen_hao') }}</div>
            <div class="val">{{ model.data.bodyNum }}</div>
          </li>
        </ul>
      </div>
      <div class="input-container">
        <el-form :model="form" :rules="rules" ref="form">
          <el-row :gutter="8">
            <el-col :span="12">
              <el-form-item :label="$t('dms_replace_parts_dialog.geng_huan_wei_zhi')" prop="componentCode">
                <custom-select
                  url="ComponentReplaceComponentList"
                  type="tree"
                  v-model="form.componentCode"
                  :show-all-levels="false"
                  :params="{ bodyNum: model.data.bodyNum }"
                  :props="{
                    label: 'componentName',
                    value: 'componentCode',
                    emitPath: false,
                  }"
                  width="100%"
                  ref="component"
                  @treeValChange="componentCodeChange"
                ></custom-select>
              </el-form-item>
            </el-col>
          </el-row>
          <custom-tab v-model="tabActive" :list="tabList" v-if="form.partList.length > 1"></custom-tab>
          <!-- 内容 -->
          <div class="conten-box" v-for="(item, index) in form.partList" :key="index">
            <template v-if="form.partList.length > 1">
              <el-row :gutter="8" v-show="`${tabActive}` === `${item.tabIndex}`">
                <el-col :span="12">
                  <h1 class="item-title">{{ $t('dms_replace_parts_dialog.jiu_ling_jian_xin_xi') }}</h1>
                  <el-col>
                    <el-form-item :label="$t('dms_replace_parts_dialog.jljbh')" :prop="`partList[${index}].oldPartCode`" :rules="rules.oldPartCode">
                      <custom-select
                        url="partList"
                        :filterable="true"
                        v-model="item.oldPartCode"
                        :placeholder="$t('Common.com_please_select')"
                        :props="{ label: 'codeName', value: 'partCode' }"
                        remote
                        :listener="item.oldPartCode"
                        :params="{ isLimit: true, keyword: item.oldPartCode }"
                        width="100%"
                        @change="oldPartCodeChange(arguments[0], item)"
                      ></custom-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('dms_replace_parts_dialog.jiu_ling_jian_gui_ge')" :prop="`partList[${index}].oldPartSpec`">
                      <el-input v-model="item.oldPartSpec" style="100%" :disabled="true"></el-input>
                      <!-- <p>{{item.oldPartSpec}}</p> -->
                    </el-form-item>
                  </el-col>
                  <el-col v-if="`${item.needSn}` !== '0'">
                    <!-- :gutter="8" -->
                    <el-row>
                      <el-col :span="19">
                        <!-- :rules="`${item.needSn}`==='1'?rules.oldPartSn:[]" -->
                        <el-form-item :label="$t('dms_replace_parts_dialog.jiu_ling_jianSN')" :prop="`partList[${index}].oldPartSn`">
                          <el-input v-model="item.oldPartSnSelf" style="100%" :disabled="true"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-form-item>
                          <label slot="label">&nbsp;</label>
                          <el-button style="width: 100%" type="text" @click="oldPartSnChange(item)">{{ $t('Common.com_modify') }}</el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col v-if="`${item.needSn}` === '0' && +item.partCount > 1">
                    <el-form-item :label="$t('dms_replace_parts_dialog.geng_huan_shu_liang')" :prop="`partList[${index}].replaceNum`" :rules="rules.replaceNum">
                      <el-input v-model="item.replaceNum" style="100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('dms_replace_parts_dialog.jljtp')">
                      <div>
                        <t-upload
                          :bizId="item.partId"
                          bizType="asm.service.part.old"
                          v-model="item.oldAttachList"
                          :limit="3"
                          :tip="$t('dms_replace_parts_dialog.znscjpgpngwjqbcg2MB')"
                          :ref="`asmServicePartOld${index}`"
                          :autoUpload="false"
                        ></t-upload>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="12">
                  <h1 class="item-title">{{ $t('dms_replace_parts_dialog.xin_ling_jian_xin_xi') }}</h1>
                  <el-col>
                    <el-form-item :label="$t('dms_replace_parts_dialog.xljbh')" :prop="`partList[${index}].partCode`" :rules="rules.partCode">
                      <custom-select
                        url="partList"
                        :filterable="true"
                        v-model="item.partCode"
                        :placeholder="$t('Common.com_please_select')"
                        :props="{ label: 'codeName', value: 'partCode' }"
                        remote
                        :listener="item.partCode"
                        :params="{ isLimit: true, keyword: item.partCode }"
                        width="100%"
                        @change="partCodeChange(arguments[0], item)"
                      ></custom-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('dms_replace_parts_dialog.xin_ling_jian_gui_ge')" :prop="`partList[${index}].partSpec`">
                      <el-input v-model="item.partSpec" style="100%" :disabled="true"></el-input>
                      <!-- <p>{{item.partSpec}}</p> -->
                    </el-form-item>
                  </el-col>
                  <el-col v-if="`${item.needSn}` !== '0'">
                    <el-form-item :label="$t('dms_replace_parts_dialog.xin_ling_jianSN')" :prop="`partList[${index}].partSn`" :rules="`${item.needSn}` === '1' ? rules.partSn : []">
                      <el-input v-model="item.partSn" style="100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('dms_replace_parts_dialog.xljtp')">
                      <div>
                        <!-- :tip="$t('page_content_part_information')" -->
                        <t-upload
                          :bizId="item.partId"
                          bizType="asm.service.part.new"
                          v-model="item.newAttachList"
                          :limit="3"
                          :tip="$t('dms_replace_parts_dialog.znscjpgpngwjqbcg2MB')"
                          :ref="`asmServicePartNew${index}`"
                          :autoUpload="false"
                        ></t-upload>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </template>
            <template v-else>
              <el-row :gutter="8">
                <el-col :span="12">
                  <h1 class="item-title">{{ $t('dms_replace_parts_dialog.jljbh') }}</h1>
                  <el-col>
                    <el-form-item :label="$t('dms_replace_parts_dialog.jljbh')" :prop="`partList[${index}].oldPartCode`" :rules="rules.oldPartCode">
                      <custom-select
                        url="partList"
                        :filterable="true"
                        :disabled="form.componentCode === 'other'"
                        v-model="item.oldPartCode"
                        :placeholder="$t('Common.com_please_select')"
                        :props="{ label: 'codeName', value: 'partCode' }"
                        remote
                        :listener="item.oldPartCode"
                        :params="{ isLimit: true, keyword: item.oldPartCode }"
                        width="100%"
                        @change="oldPartCodeChange(arguments[0], item)"
                      ></custom-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('dms_replace_parts_dialog.jiu_ling_jian_gui_ge')" :prop="`partList[${index}].oldPartSpec`">
                      <el-input v-model="item.oldPartSpec" style="100%" :disabled="true"></el-input>
                      <!-- <p>{{item.oldPartSpec}}</p> -->
                    </el-form-item>
                  </el-col>
                  <el-col v-if="`${item.needSn}` !== '0'">
                    <!-- <el-form-item :label="$t('label_oldPartSn')" :prop="`partList[${index}].oldPartSn`" :rules="`${item.needSn}`==='1'?rules.oldPartSn:[]">
                      <el-input v-model="item.oldPartSn" style="100%" :disabled="true"></el-input>
                    </el-form-item> -->
                    <!-- :gutter="8" -->
                    <el-row>
                      <el-col :span="19">
                        <!-- :rules="`${item.needSn}`==='1'?rules.oldPartSn:[]" -->
                        <el-form-item :label="$t('dms_replace_parts_dialog.jiu_ling_jianSN')" :prop="`partList[${index}].oldPartSn`">
                          <el-input v-model="item.oldPartSnSelf" style="100%" :disabled="true"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-form-item>
                          <label slot="label">&nbsp;</label>
                          <el-button style="width: 100%" type="text" @click="oldPartSnChange(item)">{{ $t('Common.com_modify') }}</el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col v-if="`${item.needSn}` === '0' && +item.partCount > 1">
                    <el-form-item :label="$t('dms_replace_parts_dialog.geng_huan_shu_liang')" :prop="`partList[${index}].replaceNum`" :rules="rules.replaceNum">
                      <el-input v-model="item.replaceNum" style="100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('dms_replace_parts_dialog.jljtp')">
                      <div>
                        <t-upload :bizId="item.partId" bizType="asm.service.part.old" v-model="item.oldAttachList" :limit="3" :autoUpload="false" :ref="`asmServicePartOld${index}`"></t-upload>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="12">
                  <h1 class="item-title">{{ $t('dms_replace_parts_dialog.xin_ling_jian_xin_xi') }}</h1>
                  <el-col>
                    <el-form-item :label="$t('dms_replace_parts_dialog.xljbh')" :prop="`partList[${index}].partCode`" :rules="rules.partCode">
                      <custom-select
                        url="partList"
                        :filterable="true"
                        v-model="item.partCode"
                        :placeholder="$t('Common.com_please_select')"
                        :props="{ label: 'codeName', value: 'partCode' }"
                        remote
                        :listener="item.partCode"
                        :params="{ isLimit: true, keyword: item.partCode }"
                        width="100%"
                        @change="partCodeChange(arguments[0], item)"
                      ></custom-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('dms_replace_parts_dialog.xin_ling_jian_gui_ge')" :prop="`partList[${index}].partSpec`">
                      <el-input v-model="item.partSpec" style="100%" :disabled="true"></el-input>
                      <!-- {{item.partSpec}} -->
                    </el-form-item>
                  </el-col>
                  <el-col v-if="`${item.needSn}` !== '0'">
                    <el-row>
                      <el-col :span="19">
                        <el-form-item :label="$t('dms_replace_parts_dialog.xin_ling_jianSN')" :prop="`partList[${index}].partSn`" :rules="`${item.needSn}` === '1' ? rules.partSn : []">
                          <el-input v-model="item.partSn" style="100%"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <!--  v-if="form.componentCode === 'modem' || form.componentCode === 'btmd'" -->
                        <el-form-item>
                          <label slot="label">&nbsp;</label>
                          <el-button style="width: 100%" type="text" @click="onPartSnSearch(item)">{{ $t('Common.com_query') }}</el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('dms_replace_parts_dialog.xljtp')">
                      <div>
                        <t-upload :bizId="item.partId" bizType="asm.service.part.new" v-model="item.newAttachList" :limit="3" :autoUpload="false" :ref="`asmServicePartNew${index}`"></t-upload>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </template>
          </div>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onSave">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <!-- 选择设备 -->
    <device-newPartSn-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onOldNewPartSn"></device-newPartSn-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import tUpload from '@/components/upload.vue';
import deviceNewPartSnDialog from './device_newPartSn_dialog.vue';

export default {
  components: {
    tUpload,
    deviceNewPartSnDialog,
  },
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        // 部件编号
        componentCode: '',
        // 设备Id
        deviceId: '',
        // 是否下发命令 (禁止操作仅查询查看)
        isCommand: '',
        partList: [
          {
            // 部件编号
            componentCode: '',
            // 新零件图片
            newAttachList: [],
            // 旧零件图片
            oldAttachList: [],
            // 旧零件类别，1-普通，2-重大，3-耗材
            oldPartClass: '',
            // 旧零件编号
            oldPartCode: '',
            // 旧零件id
            oldPartId: '',
            // 旧零件名称
            oldPartName: '',
            // 旧零件sn
            oldPartSn: '',
            // 旧零件规格
            oldPartSpec: '',
            // 旧零件类型 asm_part_type
            oldPartType: '',
            // 零件类别，1-普通，2-重大，3-耗材
            partClass: '',
            // 零件编号
            partCode: '',
            // 零件id
            partId: '',
            // 零件名称
            partName: '',
            // 零件sn
            partSn: '',
            // 零件规格
            partSpec: '',
            // 零件类型 asm_part_type
            partType: '',
            // 更换数量
            replaceNum: 1,
          },
        ],
      },
      tabActive: 0,
      tabList: [],
      // 是否是合成部件
      isCombined: '',
      // 合成物的部件编号集合
      combineCodes: '',
      // 是否需要sn  0不要sn 需要显示 partCount 1必须 2选填
      needSn: '',
      // 更换最大值  replaceNum默认是1  needSn才是0显示
      partCount: '',
      //
      partItem: {
        // 部件编号
        componentCode: '',
        // 新零件图片
        newAttachList: [],
        // 旧零件图片
        oldAttachList: [],
        // 旧零件类别，1-普通，2-重大，3-耗材
        oldPartClass: '',
        // 旧零件编号
        oldPartCode: '',
        // 旧零件id
        oldPartId: '',
        // 旧零件名称
        oldPartName: '',
        // 旧零件sn
        oldPartSn: '',
        // 自用 旧零件sn
        oldPartSnSelf: '',
        // 旧零件规格
        oldPartSpec: '',
        // 旧零件类型 asm_part_type
        oldPartType: '',
        // 零件类别，1-普通，2-重大，3-耗材
        partClass: '',
        // 零件编号
        partCode: '',
        // 零件id
        partId: '',
        // 零件名称
        partName: '',
        // 零件sn
        partSn: '',
        // 零件规格
        partSpec: '',
        // 零件类型 asm_part_type
        partType: '',
        // 更换数量
        replaceNum: '1',
      },
      dialogVisible: false,
      dialogModel: {},
    };
  },
  computed: {
    rules() {
      return {
        componentCode: [
          {
            required: true,
            message: this.$t('dms_replace_parts_dialog.qxzbjmc'),
          },
        ],
        oldPartCode: [
          {
            required: true,
            message: this.$t('dms_replace_parts_dialog.qxzjljbh'),
          },
        ],
        oldPartSpec: [
          {
            required: true,
            message: this.$t('dms_replace_parts_dialog.qtxjljgg'),
          },
        ],
        oldPartSn: [
          {
            required: true,
            message: this.$t('dms_replace_parts_dialog.qtxjljSN'),
          },
        ],
        replaceNum: [
          { required: true, message: this.$t('dms_replace_parts_dialog.qtxghsl') },
          { min: 1, message: this.$t('Common.com_rules_number_min', [1]) },
          { validator: null, trigger: 'blur', message: this.$t('dms_replace_parts_dialog.ghljslbndyzjbddsl') },
        ],
        partCode: [
          {
            required: true,
            message: this.$t('dms_replace_parts_dialog.qxxljbh'),
          },
        ],
        partSpec: [
          {
            required: true,
            message: this.$t('dms_replace_parts_dialog.qtxljgg'),
          },
        ],
        partSn: [
          {
            required: true,
            message: this.$t('dms_replace_parts_dialog.qtxljSN'),
          },
        ],
      };
    },
  },
  mounted: function () {
    this.form.deviceId = this.model.data.deviceId || '';
    this.rules.replaceNum[2].validator = (rule, value, callback) => {
      let index = 0;
      // 获取验证字段
      const numArr = rule.field.match(/\d+/g);
      index = numArr[0];
      if (value > this.form.partList[index].partCount) {
        callback(new Error());
      } else {
        callback();
      }
    };
  },
  methods: {
    // 更换位置 部件编号
    componentCodeChange(items) {
      if (items) {
        const currentItem = items.slice(-1)[0];
        this.isCombined = currentItem.isCombined;
        this.combineCodes = currentItem.combineCodes;
        this.needSn = currentItem.needSn;
        this.partCount = currentItem.partCount;
        // 查询是否下发服务配置     服务配置标志查询
        // 1是多个
        // if (this.isCombined) {
        //   this.getByCode();
        // } else {
        //   this.getOldPartInfo();
        // }
        this.getOldPartInfo();
      }
    },
    // 旧零件
    oldPartCodeChange(info, item) {
      if (info) {
        item.oldPartCode = info.partCode;
        item.oldPartId = info.partId;
        item.oldPartName = info.partName;
        // item.partSn = info.partSn;
        item.oldPartSpec = info.partSpec;
        item.oldPartClass = info.partClass;
        item.oldPartType = info.partType;
        this.clearValidate();
      }
    },
    // 新零件
    partCodeChange(info, item) {
      if (info) {
        item.partCode = info.partCode;
        item.partId = info.partId;
        item.partName = info.partName;
        // item.partSn = info.partSn;
        item.partSpec = info.partSpec;
        item.partClass = info.partClass;
        item.partType = info.partType;
        if (this.form.componentCode === 'other') {
          item.oldPartCode = info.partCode;
          item.oldPartId = info.partId;
          item.oldPartName = info.partName;
          // item.partSn = info.partSn;
          item.oldPartSpec = info.partSpec;
          item.oldPartClass = info.partClass;
          item.oldPartType = info.partType;
        }
        this.clearValidate();
      }
    },
    // 获取合成的部件
    getByCode() {
      this.$getJSON(`${apis.productStructureGetByCode}`, {
        bodyNum: this.model.data.bodyNum,
        componentCodes: this.combineCodes,
        productCode: this.model.data.productCode,
      }).then((res) => {
        const data = res.data || [];
        // tab数据
        this.tabList = data.map((i, index) => {
          const obj = {};
          obj.name = i.componentName;
          obj.value = index;
          return obj;
        });
        this.form.partList = data.map((i, index) => {
          const obj = { ...this.partItem };
          // 部件编号
          obj.componentCode = i.componentCode;
          // 旧零件编号
          obj.oldPartCode = i.deviceStructureBo.partCode;
          // 旧零件id
          obj.oldPartId = i.deviceStructureBo.partId;
          // 旧零件名称
          obj.oldPartName = i.deviceStructureBo.partName;
          // 旧零件sn
          obj.oldPartSn = i.deviceStructureBo.partSn;
          // 自用旧零件sn
          obj.oldPartSnSelf = i.deviceStructureBo.partSn;
          // 旧零件规格
          obj.oldPartSpec = i.deviceStructureBo.partSpec;
          // 零件类别
          obj.oldPartClass = i.deviceStructureBo.partClass;
          // 零件类型
          obj.oldPartType = i.deviceStructureBo.partType;

          obj.needSn = i.needSn;
          obj.partCount = i.partCount;
          // obj.replaceNum = 1;

          obj.tabIndex = index;
          return obj;
        });
        this.clearValidate();
        // 根据返回的部件个数去生成多个零件项目
        // this.form= res.data;
      });
    },
    // 获取旧零件详情
    getOldPartInfo() {
      this.$getJSON(`${apis.stockOldPartInfo}`, {
        bodyNum: this.model.data.bodyNum,
        componentCode: this.form.componentCode,
      }).then((res) => {
        const oldPartInfo = res.data;
        // 只有一个没有tab
        this.tabList = [];
        this.form.partList = [{ ...this.partItem }];

        if (this.form.componentCode === 'other') {
          // other
          // 位置选其他  旧零件是空的  新零件选了什么 旧零件就是什么
          // 部件编号
          this.form.partList[0].componentCode = this.form.componentCode;
          // 是否需要sn
          this.form.partList[0].needSn = this.needSn;
          // 更换最大值
          this.form.partList[0].partCount = this.partCount;
        } else {
          // 部件编号
          this.form.partList[0].componentCode = this.form.componentCode;
          // 旧零件编号
          this.form.partList[0].oldPartCode = oldPartInfo.partCode;
          // 旧零件id
          this.form.partList[0].oldPartId = oldPartInfo.partId;
          // 旧零件名称
          this.form.partList[0].oldPartName = oldPartInfo.partName;
          // 旧零件sn
          this.form.partList[0].oldPartSn = oldPartInfo.partSn;
          // 自用旧零件sn
          this.form.partList[0].oldPartSnSelf = oldPartInfo.partSn;
          // 旧零件规格
          this.form.partList[0].oldPartSpec = oldPartInfo.partSpec;
          // 零件类别
          this.form.partList[0].oldPartClass = oldPartInfo.partClass;
          // 零件类型
          this.form.partList[0].oldPartType = oldPartInfo.partType;
          // 是否需要sn
          this.form.partList[0].needSn = this.needSn;
          // 更换最大值
          this.form.partList[0].partCount = this.partCount;
          // this.form.partList[0].replaceNum = 1;
        }

        this.clearValidate();
      });
    },
    onPartSnSearch() {
      this.$getJSON(`${apis.stockNewPartInfo}`, {
        bodyNum: this.model.data.bodyNum,
        componentCode: this.form.componentCode,
        partKey: this.form.partList[0].partSn,
      }).then((res) => {
        const partInfo = res.data;
        // 新编号
        this.form.partList[0].partCode = partInfo.partCode;
        // 新零件id
        this.form.partList[0].partId = partInfo.partId;
        // 新零件名称
        this.form.partList[0].partName = partInfo.partName;
        // 新零件sn
        this.form.partList[0].partSn = partInfo.partSn;
        // 新零件规格
        this.form.partList[0].partSpec = partInfo.partSpec;
        // 零件类别
        this.form.partList[0].partClass = partInfo.partClass;
        // 零件类型
        this.form.partList[0].partType = partInfo.partType;
        // this.form.partList[0].replaceNum = 1;
        this.clearValidate();
      });
    },
    oldPartSnChange(item) {
      this.dialogModel.title = this.$t('dms_replace_parts_dialog.xgjljSN');
      this.dialogModel.data = item;
      this.dialogVisible = true;
    },
    //
    onOldNewPartSn(form) {
      this.dialogModel.data.oldPartSnSelf = form.oldPartSn;
      this.$set(this.dialogModel.data, 'oldNewPartSn', form.oldPartSn);
    },
    clearValidate() {
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }
    },
    async onSave() {
      this.$refs.form.validate(async (val, failItems) => {
        const ret = [];
        this.form.partList.forEach(async (item, i) => {
          ret.push(this.$refs[`asmServicePartOld${i}`][0].submit());
          ret.push(this.$refs[`asmServicePartNew${i}`][0].submit());
        });
        await Promise.all(ret);
        if (val) {
          this.form.deviceId = this.model.data.deviceId;
          this.$postJSON(apis.stockDevicePartReplace, this.form).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.$emit('success');
            this.visible = false;
          });
        } else {
          for (const key in failItems) {
            // obj[key][0].message
            const numArr = key.match(/\d+/g);
            // 切换到当前报错的tab
            this.tabActive = numArr[0];
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.replace-parts-dialog {
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .dialog-body {
    width: 100%;
    padding: 0 !important;
    display: flex;
    .msg-content {
      width: 260px;
      padding: 0 24px 40px;
      // height: 100%;
      background: #f8f9fb;
      .title {
        $h: 60px;
        height: $h;
        line-height: $h;
        color: #495057;
        font-weight: bold;
        font-size: 14px;
      }
      .msg-list {
        > li {
          overflow: hidden;
          padding-top: 9px;
          padding-bottom: 10px;
          color: #6c757d;
          font-size: 12px;
          line-height: 17px;
          border-bottom: 1px solid #eef2f7;
          .key {
            float: left;
            width: 50%;
          }
          .val {
            float: left;
            text-align: right;
            width: 50%;
          }
        }
      }
    }
    .input-container {
      flex: 1;
      padding: 24px 24px 0 24px;
      background: #fff;
    }
    .conten-box {
      padding-top: 16px;
    }
  }
}
</style>
